export default {
  grid: {
    quickLayout: 'Quick layout',
    toolbar: {
      select: 'Select',
      eraser: 'Eraser',
      selectAll: 'Select all',
      clear: 'Clear',
      reset: 'Reset',
    },
    board: {
      form: {
        number: {
          label: 'Number of rows and columns',
          row: 'Row',
          col: 'Column',
        },
        type: {
          label: 'Arrangement',
          normal: 'Alignment',
          offset: 'Column Misalignment',
          offsetY: 'Row Misalignment',
        },
        background: {
          add: 'Add Background',
          label: 'Single grid image',
          name: 'Square BG',
          edit: 'Edit',
          change: 'Replace',
        },
      },
      boardTips:
        'Reminder: If the grid has been redesigned, please be sure to enter the "Element" to rearrange the design',
      clickTips: 'Click/drag to select the square',
    },
    chess: {
      name: 'Element',
      element: {
        title: 'Element selection',
        add: 'Add element',
      },
      percent: {
        title: 'Arrange by weight',
        rule: 'The sum of weights must be equal to 100%, please reconfigure',
      },
      submit: 'Apply to Grid Board',
    },
    tab: {
      board: 'Grid',
      chess: 'Element',
    },
  },
  dialog: {
    submit: 'Confirm',
    cancel: 'Cancel',
    select: {
      creatived: 'Please select an activated grid.',
      layout: 'Please select the element to place from the right panel.',
    },
  },
}
